export default "__VITE_ASSET__CNaXcyg3__"